import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFloppyDisk1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFloppyDisk1"><Path d="M7 3H3V21H7V12H17V21H21V6.58579L17.4142 3H17V9H7V3Z" fill="currentColor"/><Path d="M15 3H9V7H15V3Z" fill="currentColor"/><Path d="M15 21V14H9V21H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFloppyDisk1;
